import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Grid, InputBase, makeStyles, Theme, Typography } from '@material-ui/core';
import { primaryGray, white } from 'src/components/colors';
import { DownArrowIcon, PlusIcon, UpArrow } from 'src/components/Icons';
import useStyles from "src/app/maintenance/assets/styles";

export function DropDownExisting(props) {
  const classes = local();
  const style = useStyles();
  const [isDropDown, setIsDropDown] = useState(false);
  const dropdownRef = useRef(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropDown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDropDown = (type) => {
    if (props.kitModelFormType !== 'Edit') {
      if (!(type === "space" && isDropDown)) {
        setIsDropDown(!isDropDown);
      }
    }
  };

  useEffect(() => {
    if (typeof props.value === 'string') {
      setSearchQuery(props.value);
      handleSearchOption(props.value);
    }
  }, [props.value]);

  const handleValue = (e) => {
    setSearchQuery(e);
    handleKitModels(e);
  };

  const handleKitModels = (e) => {
    props.setSelectKitModel(e);
    props.setModelError({ error: false, errorMessage: '' });
  };

  const handleAddClick = () => {
    props.setIsAddClick(true);
    setIsDropDown(false);
  };

  const handleSearchOption = (input) => {
    const value = typeof input === 'string' ? input : input.target.value || '';
    setSearchQuery(value);

    if (props.kitModelFormType !== 'Edit') {
      if (value === '') {
        setSelectOptions(props.options);
      } else {
        const filtered = props.options.filter((option) =>
          option.toLowerCase().includes(value.toLowerCase())
        );
        setSelectOptions(filtered);
      }
    }
  };

  return (
    <Grid ref={dropdownRef} container style={{ height: '40px' }}>
      <Grid
        container
        className={style.formInput}
        style={{
          border: props.borderStyle || '1px solid #e0e0e0',
          backgroundColor: white,
          paddingRight: '0',
          cursor: 'pointer',
          margin: '0px',
        }}
        alignContent="center"
        onClick={() => handleDropDown("space")}
      >
        <Grid item xs={11} md={11}>
          <InputBase
            type="text"
            placeholder={props.emptyTag}
            classes={{
              input: props.applyCustomPlaceholder ? classes.input : classes.inputBaseCustom,
            }}
            value={searchQuery}
            onChange={handleSearchOption}
            fullWidth
            autoFocus
          />
        </Grid>
        {props.kitModelFormType !== 'Edit' && (
          <Grid item xs={1} md={1} style={{ textAlign: 'center' }} onClick={() => handleDropDown("arrow")}>
            {isDropDown ? <UpArrow /> : <DownArrowIcon />}
          </Grid>
        )}
      </Grid>

      {isDropDown && (
        <div
          style={{
            textAlign: 'left',
            border: '.75px solid rgba(63, 68, 81, 0.12)',
            borderRadius: '5px',
            backgroundColor: white,
            width: '100%',
            zIndex: '1',
            maxHeight: '160px',
            overflowY: 'auto',
          }}
        >
          {props.isAddRequired && (
            <Grid item className={style.option} onClick={handleAddClick}>
              <Grid container style={{ marginTop: '5px' }}>
                <Grid
                  item
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: white,
                    borderRadius: '50%',
                    boxShadow: "0px 4px 8px #0000001F",
                    width: '20px',
                    height: '20px',
                  }}
                >
                  <PlusIcon />
                </Grid>
                <Typography style={{ paddingLeft: '10px' }}>{props.emptyTag}</Typography>
              </Grid>
            </Grid>
          )}

          {selectOptions.map((option, index) => (
            <Grid
              item
              className={style.option}
              onClick={() => {
                handleValue(option);
                props.isSingle && handleDropDown("value");
              }}
              key={index}
            >
              {typeof option === 'object' ? option.label : option}
            </Grid>
          ))}
        </div>
      )}
    </Grid>
  );
}

const local = makeStyles((theme: Theme) => ({
  input: {
    "&::placeholder": {
      color: primaryGray,
      opacity: 1,
      fontFamily: "'Poppins', sans-serif",
      fontSize: '14px',
    },
  },
  inputBaseCustom: {
    border: 'none',
    cursor: 'pointer',
    backgroundColor: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '13px',
  },
}));
